import type {
  ExternalCourse,
  ExternalSubject,
  Institution,
  SubjectSearchItem,
} from './api'

export function displayInstitution(institution: Institution | null): string {
  if (institution == null) return ''
  return institution.country ? `${institution.name} - ${institution.country.name}` : institution.name
}

export function displaySubject(subject: SubjectSearchItem): string {
  return `${subject.subject_code} - ${subject.subject_name}`
}

export function courseSubjects(course: ExternalCourse): ExternalSubject[] {
  return course.subjects.length > 0 ? course.subjects : course.external_subjects
}

export function subjectDisplayCode(subject: ExternalSubject): string {
  return subject.external_subject_code
}
